import { css } from 'styled-components';
import { typography } from '../../../theme/typography';
import { breakpointLG } from './breakpoints';
const fontRegularCommon = css `
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: normal;
`;
export const fontRegular12 = css `
  ${fontRegularCommon};
  font-size: 12px;
  line-height: 16px;
`;
export const fontRegular14 = css `
  ${fontRegularCommon};
  font-size: 14px;
  line-height: 18px;
`;
export const fontRegular16 = css `
  ${fontRegularCommon};
  font-size: 16px;
  line-height: 24px;
`;
export const fontRegular24 = css `
  ${fontRegularCommon};
  font-size: 24px;
  line-height: 32px;
`;
const fontSemiboldCommon = css `
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
`;
export const fontSemibold12 = css `
  ${fontSemiboldCommon};
  font-size: 12px;
  line-height: 20px;
`;
export const fontSemibold14 = css `
  ${fontSemiboldCommon};
  font-size: 14px;
  line-height: 18px;
`;
export const fontSemibold16 = css `
  ${fontSemiboldCommon};
  font-size: 16px;
  line-height: 24px;
`;
export const fontSemibold20 = css `
  ${fontSemiboldCommon};
  font-size: 20px;
  line-height: 28px;
`;
export const body1 = css `
  font-family: ${typography.fontFamilyV2};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.12px;
`;
export const subTitle2 = css `
  font-family: ${typography.fontFamilyV2};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.12px;

  @media (max-width: ${breakpointLG}) {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }
`;
export const button = css `
  font-family: ${typography.fontFamilyV2};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.12px;
`;
//# sourceMappingURL=fonts.js.map